import dayjs from 'dayjs';

const EXPIRING_SOON_DAYS = 30;

export type SubscriptionStatusLabel = 'Active' | 'Expiring' | 'Expired';

export const getSubscriptionStatusLabel = (expiresAt: string): SubscriptionStatusLabel => {
  const daysRemaining = dayjs(expiresAt).diff(dayjs(), 'day');
  if (daysRemaining < 0) return 'Expired';
  if (daysRemaining <= EXPIRING_SOON_DAYS) return 'Expiring';
  return 'Active';
};
